import { faHeart } from '@fortawesome/pro-solid-svg-icons';

import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { SwitchIcon } from '@sorare/core/src/atoms/icons/SwitchIcon';
import { useFacet } from '@sorare/core/src/contexts/graphql-search';
import { useLoggedCallback } from '@sorare/core/src/hooks/useLoggedCallback';
import { useEvents } from '@sorare/core/src/lib/events/useEvents';
import { VIRTUAL_TOGGLE_FILTERS } from '@sorare/core/src/lib/filters';

import { useVirtualFilterSegment } from 'searchCards/Segment/VirtualFilterSegment/useVirtualFilterSegment';

const { favoriteFilter } = VIRTUAL_TOGGLE_FILTERS;

export const FavoriteFilter = () => {
  const { onChange, checked } = useVirtualFilterSegment({
    filter: favoriteFilter,
    needsLogin: true,
  });
  return (
    <Button key="favorite" color="tertiary" size="small" onClick={onChange}>
      <FontAwesomeIcon icon={faHeart} />
      <SwitchIcon size="small" checked={checked} />
    </Button>
  );
};

export const BackendFavoriteFilter = () => {
  const {
    value: [checkedString],
    refine,
  } = useFacet(favoriteFilter.name);
  const track = useEvents();

  const checked = checkedString === 'true';
  const onChange = useLoggedCallback(() => {
    refine(() => (checked ? [] : ['true']));
    track('Use Market Filter', {
      filterName: favoriteFilter.trackingName,
      filterValue: (!checked).toString(),
    });
  });

  return (
    <Button key="favorite" color="tertiary" size="small" onClick={onChange}>
      <FontAwesomeIcon icon={faHeart} />
      <SwitchIcon size="small" checked={checked} />
    </Button>
  );
};
